import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Helmet } from 'react-helmet';
import TermosUso from '../termsModal/';
import './register.page.component.css';
import JusInput from 'component/newInput.component';
import Button from 'component/button.component';
import { userRegister, userLogin } from 'store/action/user.action';
import {
  USER_REGISTER_ERROR,
  USER_REGISTER_SUCCESS,
  USER_LOGIN_ERROR,
  USER_LOGIN_SUCCESS,
} from 'config/constants';
import { toast } from 'react-toastify';
import MailOutlineIcon from '@material-ui/icons/MailOutline';
import PersonIcon from '@material-ui/icons/Person';
import VpnKeyIcon from '@material-ui/icons/VpnKey';
import SocialAccess from '../social/';
import { Checkbox } from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  margin: {
    margin: theme.spacing(1),
  },
}));

export default function Register({ setLoading }) {
  const classes = useStyles();
  const [controlValues, setValues] = React.useState({
    email: '',
    emailError: false,
    name: '',
    nameError: false,
    oab: '',
    oabError: false,
    password_req: '',
    passwordError: false,
    password_confirmation: '',
    repasswordError: false,
    accepted_terms: false,
    modalOpen: false,
  });

  const _userLogin = user => {
    userLogin(user)
      .then(({ type, message }) => {
        if (type === USER_LOGIN_SUCCESS) {
          window.location.href = '/';
        } else if (type === USER_LOGIN_ERROR) {
          toast.error(
            'Falha ao realizar o login após cadastro. Realize o login manualmente!'
          );
        }
      })
      .catch(err => {
        console.error('Por favor, entre em contato com o suporte.');
      });
  };

  const _onRegister = () => {
    const {
      email,
      name,
      accepted_terms,
      password_req,
      password_confirmation,
    } = controlValues;
    let user = { user_roles: [2] };
    let oab = controlValues.oab;

    if (!accepted_terms) {
      toast.error('Necessário ler e aceitar os Termos de Uso');
      return;
    }
    setLoading(true);

    oab = oab.toUpperCase();

    user = {
      ...user,
      email,
      name,
      oab,
      password_req,
      password_confirmation,
    };

    userRegister(user)
      .then(({ type, message }) => {
        if (type === USER_REGISTER_SUCCESS) {
          toast.success('Usuário criado com sucesso!');
          setTimeout(() => {
            _userLogin({
              type: 'DEFAULT',
              login: user.email,
              password: user.password_req,
            });
          }, 3000);
        } else if (type === USER_REGISTER_ERROR) {
          toast.error(message);
        }
      })
      .catch(error => {
        console.error(error);
        toast.error('Por favor, entre em contato com o suporte.');
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const _onChangeTerms = e => {
    setValues(prevState => ({
      ...prevState,
      accepted_terms: e.currentTarget.checked,
    }));
  };

  const _openModalTerms = () => {
    setValues(prevState => ({
      ...prevState,
      modalOpen: true,
    }));
  };

  const _closeModalClick = () => {
    setValues({
      ...controlValues,
      modalOpen: false,
    });
  };

  const validateForm = () => {
    let isOk = true;
    
    if (controlValues.oab.length > 0 && controlValues.oab.length < 10) {
      toast.error('A OAB informada está incorreta.');
      setValues(prevState => ({
        ...prevState,
        oabError: true,
      }));
      isOk = false;
    }
    if (controlValues.email.length <= 0) {
      toast.error('Informe seu Email para se cadastrar.');
      setValues(prevState => ({
        ...prevState,
        emailError: true,
      }));
      isOk = false;
    }
    if (controlValues.name.length <= '') {
      toast.error('Informe seu Nome Completo para se cadastrar.');
      setValues(prevState => ({
        ...prevState,
        nameError: true,
      }));
      isOk = false;
    }
    if (controlValues.oab.includes('_')) {
      toast.error('Nº da OAB inválido.');
      isOk = false;
    }
    if (controlValues.password_req.length <= 0) {
      toast.error('Informe a senha para se cadastrar.');
      setValues(prevState => ({
        ...prevState,
        passwordError: true,
      }));
      isOk = false;
    }
    if (controlValues.password_confirmation.length <= 0) {
      toast.error('Informe a confirmação de senha para se cadastrar.');
      setValues(prevState => ({
        ...prevState,
        repasswordError: true,
      }));
      isOk = false;
    } else if (
      controlValues.password_confirmation !== controlValues.password_req
    ) {
      toast.error('Senhas devem ser iguais.');
      isOk = false;
    }

    return isOk;
  };

  const submitForm = e => {
    if (validateForm()) {
      _onRegister();
    }
  };

  const onValueChange = (value, prop) => {
    setValues({
      ...controlValues,
      [prop]: value,
    });
  };

  return (
    <div className="container flex-column align-stretch">
      <Helmet>
        <title>Acessar o Juslabore</title>
        <meta
          name="description"
          content="Cadastra-se agora, gratuitamente. E faça parte da nossa comunidade de conhecimento"
        />
      </Helmet>
      <h3 className="self-align-center" style={{ marginBottom: 20 }}>
        Falta pouco para criar sua <b>conta gratuita!</b>
      </h3>

      <SocialAccess />

      <form
        onSubmit={e => submitForm(e)}
        style={{ textAlign: '-webkit-center' }}
      >
        <div className={classes.margin}>
          <JusInput
            IconComponent={MailOutlineIcon}
            label={'Informe seu email'}
            isRequired={true}
            setValue={onValueChange}
            property={'email'}
            setError={controlValues.emailError}
          />

          <JusInput
            IconComponent={PersonIcon}
            label={'Nome completo'}
            isRequired={true}
            setValue={onValueChange}
            property={'name'}
            setError={controlValues.nameError}
          />

          <JusInput
            IconComponent={PersonIcon}
            label={'Informe sua OAB (opcional)'}
            setValue={onValueChange}
            property={'oab'}
            setError={controlValues.oabError}
          />

          <JusInput
            IconComponent={VpnKeyIcon}
            label={'Cadastre sua senha'}
            isPassword={true}
            setValue={onValueChange}
            property={'password_req'}
            setError={controlValues.passwordError}
          />

          <JusInput
            IconComponent={VpnKeyIcon}
            label={'Confirme sua senha'}
            isPassword={true}
            setValue={onValueChange}
            property={'password_confirmation'}
            setError={controlValues.repasswordError}
          />
        </div>

        <div
          className="row"
          style={{
            justifyContent: 'center',
            marginTop: '50px',
          }}
        >
          <Checkbox
            disabled
            checked={controlValues.accepted_terms}
            color="primary"
          />

          <span
            onClick={_openModalTerms}
            style={{
              cursor: 'pointer',
              fontWeight: 'bold',
              alignSelf: 'center',
              textDecoration: 'underline',
            }}
            onMouseOver={event => {
              event.target.style.textDecoration = 'none';
            }}
            onMouseLeave={event => {
              event.target.style.textDecoration = 'underline';
            }}
          >
            Clique aqui para ler e aceitar os termos de uso do Juslabore
          </span>
        </div>

        <Button
          className="self-align-end"
          onClick={e => submitForm(e)}
          text="CADASTRAR"
          style={{
            backgroundColor: '#185335',
            marginTop: 80,
            width: 200,
            alignSelf: 'center',
          }}
        />
      </form>

      <TermosUso
        isOpen={controlValues.modalOpen}
        closeModal={_closeModalClick}
        onClickAgreeTerms={_onChangeTerms}
        defaultChecked={controlValues.accepted_terms}
      />
    </div>
  );
}

//export default Register();
